import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';   
import App from './App'; 
import reportWebVitals from './reportWebVitals'; 
import MasterState from './context/MasterState'
import { BrowserRouter } from "react-router-dom"; 
import ScrollToTop from './components/added/ScrollToTop'; 
import FontIcons from './components/design/fonts/FontIcons';  
import { EventConfigProvider } from './context/EventConfigContext';
import AdminToolbar from './admin/AdminToolbar';




const root = ReactDOM.createRoot(document.getElementById('application'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop> 
        <MasterState>  
            <EventConfigProvider>
              <FontIcons>    
                  <AdminToolbar> 
                    <App /> 
                  </AdminToolbar>
              </FontIcons> 
            </EventConfigProvider>
        </MasterState>  
      </ScrollToTop>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
